import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import { Status } from '../special/Status';
import { getStatusOptions } from './statusDefinitions';

const StatusFilterChips = ({ resource, selectedStatuses, onChange, breakdown }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const options = getStatusOptions(resource);
  const allActive = !selectedStatuses || selectedStatuses.length === 0;

  const countByStatus = (status) => {
    const row = breakdown?.find?.((b) => b.status === status);
    return row?.count ?? 0;
  };
  const totalCount = breakdown?.reduce((acc, b) => acc + (b.count ?? 0), 0) ?? 0;

  const toggleStatus = (status) => {
    if (allActive) {
      onChange(options.filter((o) => o.status !== status).map((o) => o.status));
      return;
    }
    const isSelected = selectedStatuses.includes(status);
    let next = isSelected
      ? selectedStatuses.filter((s) => s !== status)
      : [...selectedStatuses, status];
    if (next.length === options.length || next.length === 0) {
      onChange(null);
    } else {
      onChange(next);
    }
  };

  const isSelected = (status) =>
    allActive || (selectedStatuses && selectedStatuses.includes(status));

  return (
    <Box className="flex flex-wrap gap-1.5 items-center">
      <Box
        onClick={() => onChange(null)}
        sx={{
          cursor: 'pointer',
          paddingX: 1.5,
          paddingY: 0.5,
          borderRadius: '999px',
          fontSize: '0.78rem',
          fontWeight: allActive ? 600 : 400,
          color: allActive ? colors.text : `${colors.text}99`,
          backgroundColor: allActive ? colors.selected : 'transparent',
          border: `1px solid ${colors.selected}`,
          transition: 'all 0.15s ease',
          '&:hover': { backgroundColor: colors.selected },
        }}
      >
        {t('All')}
        {breakdown && (
          <Box component="span" sx={{ opacity: 0.55, marginLeft: 0.75 }}>
            {totalCount}
          </Box>
        )}
      </Box>
      {options.map((opt) => {
        const selected = isSelected(opt.status);
        const count = countByStatus(opt.status);
        const label = breakdown ? `${t(opt.labelKey)} · ${count}` : t(opt.labelKey);
        return (
          <Box
            key={opt.status}
            onClick={() => toggleStatus(opt.status)}
            sx={{
              cursor: 'pointer',
              opacity: selected ? 1 : 0.35,
              transition: 'opacity 0.15s ease',
              '&:hover': { opacity: selected ? 1 : 0.7 },
              '& > div, & > button': {
                width: 'auto !important',
                pointerEvents: 'none',
              },
            }}
          >
            <Status
              text={label}
              variant={opt.variant}
              fullWidth={false}
              disableMobile
            />
          </Box>
        );
      })}
    </Box>
  );
};

export default StatusFilterChips;
